/* ============================================
   MISSION 1o2 - JAVASCRIPT
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {
    // Initialize GSAP
    gsap.registerPlugin(ScrollTrigger);

    // Run loader animation
    initLoader();

    // Initialize components
    initNavigation();
    initBubbleCanvas();
    initScrollAnimations();
    initMoleculeScrollAnimation();
    initForms();
    initMobileMenu();
});

/* ---------- Loader Animation ---------- */
function initLoader() {
    const loader = document.getElementById('loader');
    const loaderBubbles = document.getElementById('loaderBubbles');

    // If loader elements are missing, skip safely
    if (!loader || !loaderBubbles) {
        console.warn('Loader elements not found, skipping loader init');
        return;
    }

    for (let i = 0; i < 20; i++) {
        createLoaderBubble(loaderBubbles);
    }

    setTimeout(() => {
        loader.classList.add('hidden');
        document.body.style.overflow = 'auto';
    }, 1500);
}


function createLoaderBubble(container) {
    if (!container) return;

    const bubble = document.createElement('div');
    bubble.style.cssText = `
        position: absolute;
        width: ${Math.random() * 30 + 10}px;
        height: ${Math.random() * 30 + 10}px;
        background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.4), rgba(0,255,106,0.2));
        border-radius: 50%;
        left: ${Math.random() * 100}%;
        bottom: -50px;
        opacity: 0;
        animation: loaderBubbleFloat ${Math.random() * 3 + 2}s ease-out forwards;
        animation-delay: ${Math.random() * 0.5}s;
    `;

    container.appendChild(bubble);
}


// Add loader bubble animation to document
if (!document.getElementById('mission1o2-loader-styles')) {
const loaderStyle = document.createElement('style');
loaderStyle.textContent = `
    @keyframes loaderBubbleFloat {
        0% {
            opacity: 0;
            transform: translateY(0) scale(0);
        }
        20% {
            opacity: 0.8;
            transform: translateY(-100px) scale(1);
        }
        100% {
            opacity: 0;
            transform: translateY(-100vh) scale(1.2);
        }
    }
`;
document.head.appendChild(loaderStyle);
}
/* ---------- Navigation ---------- */
function initNavigation() {
    const navbar = document.getElementById('navbar');

    // Scroll effect for navbar
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    });

    // Smooth scroll for navigation links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                // Close mobile menu if open
              const mobileMenu = document.getElementById('mobileMenu') || document.getElementById('sideMenu');
if (mobileMenu) mobileMenu.classList.remove('active', 'open');

                const headerOffset = 80;
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}

/* ---------- Mobile Menu ---------- */
function initMobileMenu() {
    const hamburgerBtn = document.getElementById('hamburgerBtn');
    const mobileMenu = document.getElementById('mobileMenu');

    // Check if elements exist before adding event listeners
    if (!hamburgerBtn || !mobileMenu) {
        console.log('Mobile menu elements not found, skipping initialization');
        return;
    }

    hamburgerBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent event bubbling
        mobileMenu.classList.toggle('active');
        hamburgerBtn.classList.toggle('active');
    });

    // Close menu when clicking on mobile links
    const mobileLinks = document.querySelectorAll('.mobile-link, .mobile-link-secondary');
    mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
            mobileMenu.classList.remove('active');
            hamburgerBtn.classList.remove('active');
        });
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
        if (!mobileMenu.contains(e.target) && !hamburgerBtn.contains(e.target)) {
            mobileMenu.classList.remove('active');
            hamburgerBtn.classList.remove('active');
        }
    });
}

/* ---------- Bubble Canvas Animation ---------- */
function initBubbleCanvas() {
    const canvas = document.getElementById('bubbleCanvas');
    
    // If canvas element is missing, skip safely
    if (!canvas) {
        console.warn('Bubble canvas element not found, skipping bubble animation');
        return;
    }
    
    const ctx = canvas.getContext('2d');

    let bubbles = [];
    let animationId;

    function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    }

    function createBubble() {
        return {
            x: Math.random() * canvas.width * 0.3,
            y: canvas.height + 50,
            radius: Math.random() * 25 + 5,
            speedX: Math.random() * 0.5 + 0.2,
            speedY: Math.random() * 1 + 0.5,
            opacity: Math.random() * 0.4 + 0.1,
            wobble: Math.random() * Math.PI * 2,
            wobbleSpeed: Math.random() * 0.02 + 0.01,
            hue: Math.random() > 0.5 ? 120 : 200 // Green or Blue
        };
    }

    function initBubbles() {
        bubbles = [];
        for (let i = 0; i < 30; i++) {
            const bubble = createBubble();
            bubble.y = Math.random() * canvas.height;
            bubble.x = Math.random() * canvas.width * 0.5;
            bubbles.push(bubble);
        }
    }

    function drawBubble(bubble) {
        ctx.beginPath();

        // Create gradient for bubble
        const gradient = ctx.createRadialGradient(
            bubble.x - bubble.radius * 0.3,
            bubble.y - bubble.radius * 0.3,
            0,
            bubble.x,
            bubble.y,
            bubble.radius
        );

        gradient.addColorStop(0, `hsla(${bubble.hue}, 100%, 80%, ${bubble.opacity})`);
        gradient.addColorStop(0.5, `hsla(${bubble.hue}, 80%, 60%, ${bubble.opacity * 0.7})`);
        gradient.addColorStop(1, `hsla(${bubble.hue}, 100%, 50%, ${bubble.opacity * 0.3})`);

        ctx.arc(bubble.x, bubble.y, bubble.radius, 0, Math.PI * 2);
        ctx.fillStyle = gradient;
        ctx.fill();

        // Add highlight
        ctx.beginPath();
        ctx.arc(
            bubble.x - bubble.radius * 0.3,
            bubble.y - bubble.radius * 0.3,
            bubble.radius * 0.2,
            0,
            Math.PI * 2
        );
        ctx.fillStyle = `rgba(255, 255, 255, ${bubble.opacity * 0.8})`;
        ctx.fill();
    }

    function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        bubbles.forEach((bubble, index) => {
            // Update position
            bubble.wobble += bubble.wobbleSpeed;
            bubble.x += bubble.speedX + Math.sin(bubble.wobble) * 0.5;
            bubble.y -= bubble.speedY;

            // Reset bubble when it goes off screen
            if (bubble.y < -bubble.radius * 2) {
                bubbles[index] = createBubble();
            }

            drawBubble(bubble);
        });

        animationId = requestAnimationFrame(animate);
    }

    // Initialize
    resizeCanvas();
    initBubbles();
    animate();

    // Handle resize
    window.addEventListener('resize', () => {
        resizeCanvas();
        initBubbles();
    });

    // Pause animation when not visible
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            cancelAnimationFrame(animationId);
        } else {
            animate();
        }
    });
}

/* ---------- Scroll Animations ---------- */
function initScrollAnimations() {
    // Animate pillars
    gsap.utils.toArray('.pillar-card').forEach((card, i) => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                start: 'top 85%',
                toggleActions: 'play none none none'
            },
            y: 60,
            opacity: 0,
            duration: 0.8,
            delay: i * 0.15,
            ease: 'power3.out'
        });
    });

    // Animate science section
    gsap.from('.science-content', {
        scrollTrigger: {
            trigger: '.science-section',
            start: 'top 70%'
        },
        x: -60,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });

    gsap.from('.science-visual', {
        scrollTrigger: {
            trigger: '.science-section',
            start: 'top 70%'
        },
        x: 60,
        opacity: 0,
        duration: 1,
        delay: 0.2,
        ease: 'power3.out'
    });

    // Animate vertical cards
    gsap.utils.toArray('.vertical-card').forEach((card, i) => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                start: 'top 85%'
            },
            y: 80,
            opacity: 0,
            duration: 0.8,
            delay: i * 0.1,
            ease: 'power3.out'
        });
    });

    // Animate signup section
    gsap.from('.signup-card', {
        scrollTrigger: {
            trigger: '.signup-section',
            start: 'top 70%'
        },
        y: 60,
        opacity: 0,
        duration: 1,
        ease: 'power3.out'
    });

    // Animate foundation cards
    gsap.utils.toArray('.foundation-card').forEach((card, i) => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                start: 'top 85%'
            },
            y: 50,
            opacity: 0,
            duration: 0.6,
            delay: i * 0.1,
            ease: 'power3.out'
        });
    });

    // Animate contact section
    gsap.from('.contact-info', {
        scrollTrigger: {
            trigger: '.contact-section',
            start: 'top 70%'
        },
        x: -40,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out'
    });

    gsap.from('.contact-form-card', {
        scrollTrigger: {
            trigger: '.contact-section',
            start: 'top 70%'
        },
        x: 40,
        opacity: 0,
        duration: 0.8,
        delay: 0.2,
        ease: 'power3.out'
    });

    // Parallax effect for hero glow
    gsap.to('.hero-glow', {
        scrollTrigger: {
            trigger: '.hero',
            start: 'top top',
            end: 'bottom top',
            scrub: 1
        },
        y: 200,
        opacity: 0
    });
}

/* ---------- Molecule Scroll Animation ---------- */
function initMoleculeScrollAnimation() {
    const scrollContainer = document.querySelector('.scroll-container');
    if (!scrollContainer) return;

    // Create the main timeline for scroll animation
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".scroll-container",
            start: "top top",
            end: "bottom bottom",
            scrub: 1,
            pin: ".sticky-section",
            anticipatePin: 1
        }
    });

    // Animate headline lines - stagger reveal
    tl.to(".line-inner", {
        y: 0,
        duration: 2,
        stagger: 0.2,
        ease: "power2.out"
    }, 0);

    // Animate molecules - fade in and float
    tl.to(".molecule", {
        opacity: 1,
        duration: 1.5,
        stagger: 0.15,
        ease: "power2.out"
    }, 0.5);

    // Add floating animation to molecules (continuous)
    gsap.to(".molecule", {
        y: "random(-30, 30)",
        x: "random(-20, 20)",
        rotation: "random(-15, 15)",
        duration: "random(3, 5)",
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        stagger: {
            each: 0.2,
            from: "random"
        }
    });

    // Fade out headline in later part of scroll
    tl.to(".main-headline", {
        opacity: 0,
        y: -50,
        duration: 1.5,
        ease: "power2.in"
    }, 3);

    // Fade in subheadline
    tl.to(".subheadline-section", {
        opacity: 1,
        y: -30,
        duration: 1.5,
        ease: "power2.out"
    }, 3.5);

    // Scale up molecules as we scroll further
    tl.to(".molecule", {
        scale: 1.5,
        duration: 2,
        stagger: 0.1,
        ease: "power2.inOut"
    }, 4);

    // Final fade out of molecules
    tl.to(".molecule", {
        opacity: 0,
        scale: 2,
        duration: 1.5,
        stagger: 0.1,
        ease: "power2.in"
    }, 6);

    // Fade out subheadline at the end
    tl.to(".subheadline-section", {
        opacity: 0,
        y: -50,
        duration: 1,
        ease: "power2.in"
    }, 6.5);
}

/* ---------- Product Scroll Section - REMOVED ---------- */
// Function removed - section no longer exists


/* ---------- Form Handling ---------- */
function initForms() {
    // Signup Form
    const signupForm = document.getElementById('signupForm');
    if (signupForm) {
        signupForm.addEventListener('submit', handleSignupSubmit);
    }

    // Ambassador Form
    const ambassadorForm = document.getElementById('ambassadorForm');
    if (ambassadorForm) {
        ambassadorForm.addEventListener('submit', handleAmbassadorSubmit);
    }

    // Contact Form
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', handleContactSubmit);
    }
}

function handleSignupSubmit(e) {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    // Validate
    if (!data.name || !data.email) {
        showToast('Please fill in all required fields', 'error');
        return;
    }

    if (!data.terms) {
        showToast('Please accept the Terms of Service', 'error');
        return;
    }

    // Simulate form submission
    console.log('Signup data:', data);

    // Show success message
    showToast('Welcome to the Mission! Check your email for confirmation.');

    // Reset form
    e.target.reset();
}

function handleAmbassadorSubmit(e) {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    // Validate required fields
    const requiredFields = ['name', 'email', 'phone', 'school', 'year', 'why'];
    const missingFields = requiredFields.filter(field => !data[field]);

    if (missingFields.length > 0) {
        showToast('Please fill in all required fields', 'error');
        return;
    }

    if (!data.terms) {
        showToast('Please confirm you are 18+ and accept the Terms', 'error');
        return;
    }

    // Simulate form submission
    console.log('Ambassador application:', data);

    // Show success message
    showToast('Application submitted! We\'ll be in touch soon.');

    // Reset form
    e.target.reset();
}

function handleContactSubmit(e) {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    // Validate required fields
    if (!data.name || !data.email || !data.subject || !data.message) {
        showToast('Please fill in all required fields', 'error');
        return;
    }

    // Simulate form submission
    console.log('Contact message:', data);

    // Show success message
    showToast('Message sent! We\'ll respond within 24-48 hours.');

    // Reset form
    e.target.reset();
}

/* ---------- Toast Notification ---------- */
function showToast(message, type = 'success') {
    const toast = document.getElementById('toast');
    const toastMessage = toast.querySelector('.toast-message');
    const toastIcon = toast.querySelector('.toast-icon');

    toastMessage.textContent = message;

    if (type === 'error') {
        toastIcon.textContent = '✕';
        toastIcon.style.background = '#ff4757';
    } else {
        toastIcon.textContent = '✓';
        toastIcon.style.background = '#00ff6a';
    }

    toast.classList.add('show');

    setTimeout(() => {
        toast.classList.remove('show');
    }, 4000);
}

/* ---------- Helper Functions ---------- */

// Email validation
function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

// Phone validation
function isValidPhone(phone) {
    const regex = /^[\d\s\-\+\(\)]{10,}$/;
    return regex.test(phone);
}

// Debounce function for resize events
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

/* ---------- Bubble Ripple Effect on Cards ---------- */
document.querySelectorAll('.vertical-card, .pillar-card, .foundation-card').forEach(card => {
    card.addEventListener('mouseenter', createRipple);
});

function createRipple(e) {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const ripple = document.createElement('div');
    ripple.className = 'ripple-effect';
    ripple.style.cssText = `
        position: absolute;
        width: 20px;
        height: 20px;
        background: radial-gradient(circle, rgba(255,255,255,0.4) 0%, transparent 70%);
        border-radius: 50%;
        left: ${x}px;
        top: ${y}px;
        transform: translate(-50%, -50%) scale(0);
        pointer-events: none;
        z-index: 10;
    `;

    card.style.position = 'relative';
    card.appendChild(ripple);

    gsap.to(ripple, {
        scale: 10,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        onComplete: () => ripple.remove()
    });
}

/* ---------- Intersection Observer for Lazy Loading ---------- */
const lazyImages = document.querySelectorAll('img[data-src]');
const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
        }
    });
}, {
    rootMargin: '50px 0px',
    threshold: 0.1
});

lazyImages.forEach(img => imageObserver.observe(img));

/* ---------- Keyboard Navigation Support ---------- */
document.addEventListener('keydown', (e) => {
    // Escape key closes mobile menu
    if (e.key === 'Escape') {
        const mobileMenu = document.getElementById('mobileMenu');
        if (mobileMenu.classList.contains('active')) {
            mobileMenu.classList.remove('active');
            document.getElementById('hamburgerBtn').classList.remove('active');
        }
    }
});

/* ---------- Print Styles Handler ---------- */
window.matchMedia('print').addEventListener('change', (e) => {
    if (e.matches) {
        // Prepare for printing
        document.querySelectorAll('.reveal').forEach(el => {
            el.style.opacity = '1';
            el.style.transform = 'none';
        });
    }
});

console.log('🚀 Mission 1o2 Website Loaded Successfully');
console.log('📧 Contact: info@mission1o2.com');